<template>
  <div class="image">
    <input v-if="!disabled"
           type="file"
           ref="fileImage"
           accept="image/png,image/jpeg"
           @change="upload">

    <div class="image-cell" v-if="!image.imagePath"></div>

    <img class="small_image" style="max-width: 150px; max-height: 150px" data-rjs="2" v-if="image.imagePath"
         :src="image.imagePath">
    <img class="small_image" style="display: none; max-width: 150px; max-height: 150px" data-rjs="2" v-else>

    <button v-if="!disabled" type="button" @click="browseImage">Upload Image</button>

    <ImageCredit v-if="image.file_id" v-model="image.hyperlink" @updated="updatedHyperlink" class="image-credit"/>

    <button v-if="!disabled && image.file_id"
            class="transparent-button"
            type="button"
            @click="deleteImage">Delete
    </button>

    <strong :class="{ loading: errorClassLoading, 'text-danger': errorClassDanger }">{{ errorText }}</strong>
  </div>
</template>

<script>
import ImageCredit from './ImageCredit';

export default {
  components: {
    ImageCredit,
  },

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default() {
        return false;
      }
    },

    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      errorClassLoading: false,
      errorClassDanger: false,
      errorText: '',
      image: null,
    };
  },

  created() {
    this.image = this.value;
  },

  watch: {
    value() {
      this.image = this.value;
    }
  },

  methods: {
    browseImage() {
      this.$refs.fileImage.click();
    },

    upload() {
      this.errorClassDanger = false;
      this.errorClassLoading = true;
      this.errorText = 'Uploading';

      let formData = new FormData(),
        content = this.$refs.fileImage.files[0];

      if (!content.type.match('image.*')) {
        this.clearFiles();

        return;
      }

      formData.append('image', content);

      this.uploadImage(formData);
    },

    uploadImage(formData) {
      formData.append('entity_type', 'interview_image');

      formData.append('file_id', this.image.file_id);

      axios.post('/ajax/image/upload', formData,
        {
          headers: {'content-type': 'multipart/form-data'}
        })
        .then((response) => {
          let image = response.data;

          image.imageId = image.file_id;
          image.imagePath = image.cropPublicPath;
          image.hyperlink = {
            text: ''
          };

          this.errorText = '';
          this.errorClassLoading = false;

          this.$emit('input', image);

          if (!this.image.file_id) {
            this.$emit('addedImage');
          }

          this.image = image;

          this.clearFiles();
        })
        .catch(() => {
          this.errorClassDanger = true;
          this.errorClassLoading = false;

          this.setError('Please upload correct image (.JPG, .PNG, 700x700px minimum)');

          this.clearFiles();
        });
    },

    deleteImage() {
      this.$emit('deleteImage');
    },

    clearFiles() {
      this.$refs.fileImage.value = "";
    },

    setError(error) {
      this.errorText = error;
    },

    updatedHyperlink(val) {
      this.image.hyperlink = val;
    }
  },
};
</script>

<style lang="scss" scoped>
  .image {
    margin-bottom: 25px;

    input[type=file] {
      display: none;
    }

    button, .image-credit {
      margin-left: 25px;
      margin-top: 30px;
    }

    .image-cell {
      width: 100px;
      height: 100px;
      border-radius: 3px;
      background-color: #dddddd;
      display: inline-block;
      vertical-align: middle;
    }

    .transparent-button {
      vertical-align: unset;
    }
  }
</style>
